// extracted by mini-css-extract-plugin
export var alignLeft = "x_rd d_fp d_bG d_dv";
export var alignCenter = "x_bP d_fq d_bD d_dw";
export var alignRight = "x_rf d_fr d_bH d_dx";
export var comparisonComponent = "x_h2 d_h2 d_bl";
export var comparisonComponentHighlighted = "x_h0 d_h0 d_bm d_cD d_w";
export var comparisonComponentContent = "x_jl d_jl d_h8 d_b2 d_b5";
export var comparisonComponentContentLeft = "x_jd d_jd d_h8 d_w d_bP";
export var comparisonComponentContentRight = "x_jf d_jf d_h8 d_w d_bP";
export var comparisonComponentContentHighlighted = "x_jh d_jh d_w d_b2 d_b5 d_bP";